import { TimePeriodResolution } from '../../../utils/timePeriod'

export function defaultDataResolutionForTimePeriodResolution(
    resolution: TimePeriodResolution
): TimePeriodResolution {
    switch (resolution) {
        case 'year':
            return 'month'
        case 'month':
            return 'day'
        case 'week':
            return 'day'
        case 'day':
            return 'hour'
        default:
            throw new Error(`Unsupported resolution: ${resolution}`)
    }
}
